import React, { useState } from 'react';
import { useOfferListFilterContext } from 'src/areas/product/components/offer-list-filter-context';
import FilterToggleButton from './filter-toggle-button';
import { AllFiltersLoader } from './all-filters';
import { IOfferListFilters } from '../types';
import { FilterPanelWrapper, FiltersDropDown, FilterBlocker } from '../styles';

export const MainOfferlistFiltersDropdown = (props: IOfferListFilters) => {
  const { applicableFilters, activeOfferlistFilters, className } = props;
  const { toggleFilter } = useOfferListFilterContext();
  const [showFilters, setShowFilters] = useState<boolean>(false);
  const closeHandler = () => setShowFilters(false);
  const toggleHandler = () => setShowFilters(!showFilters);

  return (
    <div className={className}>
      <FilterToggleButton
        toggleHandler={toggleHandler}
        activeFilters={activeOfferlistFilters.length}
      />
      {showFilters && (
        <>
          <FilterBlocker onClick={() => closeHandler()} />
          <FiltersDropDown>
            <FilterPanelWrapper>
              <AllFiltersLoader
                filters={applicableFilters}
                onToggleFilter={toggleFilter}
              />
            </FilterPanelWrapper>
          </FiltersDropDown>
        </>
      )}
    </div>
  );
};
